import React, { useState } from 'react';
import { DatePicker } from '../../ui/DatePicker';

const Tests = () => {
  const [selectedRange, setSelectedRange] = useState();
  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
      }}
    >
      <DatePicker
        navLayout="around"
        mode="range"
        required
        selectedRange={selectedRange}
        selected={selectedRange}
        onSelect={setSelectedRange}
      />
    </div>
  );
};

export default Tests;
